import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetInquiryConversionReport } from "../services/reports.services";

const InquiryConversionReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/inquiryconversionreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/inquiryconversionreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterSector = params?.filterSector;
  const InquiryType = params?.InquiryType;
  const LeadSourceID = params?.LeadSourceID;
  const AssignedUserId = params?.AssignedUserId;

  const loading = useAppSelector((state) => state.reports.loading);
  const InquiryConversionListForReport = useAppSelector(
    (state) => state.reports.InquiryConversionListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: filterSector !== "0" ? filterSector : "",
        InquiryType: InquiryType !== "0" ? InquiryType : "",
        LeadSourceID: LeadSourceID !== "0" ? LeadSourceID : 0,
        AssignedUserId: AssignedUserId !== "0" ? AssignedUserId : 0,
      };
      dispatch(GetInquiryConversionReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "InquiryConversionReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "inquiryconversionreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Inquiry Conversion Report{" "}
          <span style={{ fontSize: 15 }}>
            {InquiryConversionListForReport &&
              InquiryConversionListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            InquiryConversionListForReport &&
            InquiryConversionListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            InquiryConversionListForReport &&
            InquiryConversionListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {InquiryConversionListForReport &&
      InquiryConversionListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th style={{ background: "black", color: "white" }} className="text-center">No</th>
                <th style={{ background: "black", color: "white" }} className="text-center">
                  User Name
                </th>
                <th style={{ background: "black", color: "white" }} className="text-center">
                  Total Inquiries
                </th>
                <th style={{ background: "black", color: "white" }} className="text-center">
                  Quotation Sent
                </th>
                <th style={{ background: "black", color: "white" }} className="text-center">
                  Booking Confirmed
                </th>
                <th style={{ background: "black", color: "white" }} className="text-center">
                  Conversion %
                </th>
                <th style={{ background: "black", color: "white" }} className="text-center">
                  Avg. Day to Convert
                </th>
              </tr>
            </thead>
            <tbody>
              {InquiryConversionListForReport &&
                InquiryConversionListForReport.length > 0 &&
                InquiryConversionListForReport?.map(
                  (InquiryConversion: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {InquiryConversion?.UserName || ""}
                      </td>
                      <td className="text-center">
                        {InquiryConversion?.TotalInquiries || ""}
                      </td>
                      <td className="text-center">
                        {InquiryConversion?.QuotationSent || ""}
                      </td>
                      <td className="text-center">
                        {InquiryConversion?.BookingConfirmed || ""}
                      </td>

                      <td className="text-center">
                        {InquiryConversion?.ConversionPer
                          ? InquiryConversion?.ConversionPer + " %"
                          : ""}
                      </td>
                      <td className="text-center">
                        {InquiryConversion?.AvgDaytoConvert || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default InquiryConversionReportView;
